import {logger} from '../../logger';
import {processSchema} from './processSchema';
import {schema} from './schema';

/**
 * @deprecated This schema is no longer in use. Please use the new `generateTestIds` util.
 */
const TestID = processSchema(schema);

export {TestID};

if (typeof window !== 'undefined') {
  try {
    window.localStorage?.setItem(
      'data_test_ids',
      JSON.stringify(TestID, null, 2),
    );
  } catch (e) {
    logger.error(
      new Error(`Setting data_test_ids failed. Message: ${e.message}`),
    );

    // eslint-disable-next-line no-console
    console.log(`Setting data_test_ids failed. Message: ${e.message}`);
  }
}
